import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";

import moment from "moment";

import { Box, Typography } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

import { convertUTCDateToLocalDate } from "utils/convertUTCDateToLocalDate";

const ITEMS_TO_DISPLAY = 1;

const IFCRCertificatesDisplay = ({ certificates = [] }) => {
  const [showMore, setShowMore] = useState(false);

  const displayedItems = useMemo(
    () => (showMore ? certificates : certificates.slice(0, ITEMS_TO_DISPLAY)),
    [showMore, certificates]
  );

  if (!certificates.length) return "-";

  return (
    <Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr 1fr",
          fontWeight: 600,
          mb: 0.5,
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          Renewal No
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          Date of Issue
        </Typography>
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          Valid Upto
        </Typography>
      </Box>

      {/* Data Rows */}
      {displayedItems.map((item, index) => (
        <Box
          key={item.id ?? index}
          sx={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            mb: 0.5,
            p: 0.8,
            borderRadius: 1,
          }}
        >
          <Typography variant="body2">{item.renewalNumber || "N/A"}</Typography>

          <Typography variant="body2">
            {moment(item.dateOfIssue).isValid()
              ? convertUTCDateToLocalDate(item.dateOfIssue).format("DD-MM-YYYY")
              : "N/A"}
          </Typography>

          <Typography variant="body2">
            {moment(item.dueDate).isValid()
              ? convertUTCDateToLocalDate(item.dueDate).format("DD-MM-YYYY")
              : "N/A"}
          </Typography>
        </Box>
      ))}

      {certificates.length > ITEMS_TO_DISPLAY && (
        <Typography
          sx={{
            cursor: "pointer",
            fontSize: "14px",
            mt: 0.5,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
          onClick={() => setShowMore((prev) => !prev)}
        >
          {showMore ? (
            <>
              Show Less <KeyboardArrowUp fontSize="small" />
            </>
          ) : (
            <>
              Show More <KeyboardArrowDown fontSize="small" />
            </>
          )}
        </Typography>
      )}
    </Box>
  );
};

IFCRCertificatesDisplay.propTypes = {
  certificates: PropTypes.array,
};

export default IFCRCertificatesDisplay;
